import React from "react";
import { useEffect } from "react";
import { useMemo } from "react";
import { createContext, useState } from "react";
import query from "../server/constants.api";
import useFetch from "../server/useFetch";
import useMultipleFetch from "../server/useMultipleFetch";

export const ConfigContext = createContext();

export const useConfigContext = () => {
    const context = React.useContext(ConfigContext);
  
    if (!context) {
      throw new Error("useLangContext must be used within an LanguageProvider");
    }
    return context;
};

export const ConfigProvider = (props) => {
    const queryResults = useMultipleFetch([
        {path: query.path.globalConfiguration, id: 'getOverwallconfiguration'},
        {path: query.path.layoutZonaD, id: 'getLayoutZonaD'}
    ]);
    // const { data, isLoading } = useFetch(query.path.globalConfiguration, 'getGlobalConfiguration');
    const [currentConfig, setCurrentConfig] = useState({});

    useEffect(() => {
        if(queryResults[0]?.data?.data){
            const result = queryResults[0]?.data?.data;
            if(result?.layoutZonaD === true){
                currentConfig['LayoutZonaD'] = queryResults[1]?.data?.data;
            }
        }
    }, [queryResults[0]?.data?.data, queryResults[1]?.data?.data]);

    const value = useMemo(() => {
        return {currentConfig}
    }, [currentConfig]);

    return <ConfigContext.Provider value={value}>{props.children}</ConfigContext.Provider>
}